<div class="valueslider-container">
  <div class="valueslider-zoom-button"
       (mousedown)="startVerlaag()"
       (mouseup)="stopActie()"
       (mouseleave)="stopActie()"><span class="icon fa-solid fa-minus"></span></div>

  <div class="valueslider-track" #sliderContainer (mousedown)="onMouseDown($event)">
    <div class="valueslider-track-background"></div>
    <div class="valueslider-handle"
         [style.left.%]="handlePosition"
         [class.active]="isDragging">
      <div class="valueslider-handle-tick"></div>
    </div>
  </div>

  <div class="valueslider-zoom-button"
       (mousedown)="startVerhoog()"
       (mouseup)="stopActie()"
       (mouseleave)="stopActie()"><span class="icon fa-solid fa-plus"></span></div>

  @if (reset !== undefined) {
    <div class="valueslider-zoom-button valueslider-reset-button" (click)="resetWaarde()"><span class="icon fa-solid fa-up-right-and-down-left-from-center"></span></div>
  }
</div>
